import styled from 'styled-components';
import { Annotation } from '../../../../theme/typography';

export const LoaderWrapper = styled.div`
  margin: auto;

  .loader {
    position: relative;
  }
`;

export const Information = styled(Annotation)`
  margin-top: auto;
  margin-bottom: 30px;
`;
